<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useDashboardNotifications } from '@/composables/useDashboardNotifications'
import DashboardNavIcon from '@/components/dashboard/shell/DashboardNavIcon.vue'

const { t } = useI18n()
const router = useRouter()
const { showSwiftaidStatusNotification, needsAuthorisation, needsLinkedAccount } =
  useDashboardNotifications()

const bodyKey = computed(() => {
  if (needsAuthorisation.value && needsLinkedAccount.value) {
    return 'Dashboard.Notifications.SwiftaidStatus.BodyBoth'
  }
  if (needsAuthorisation.value) {
    return 'Dashboard.Notifications.SwiftaidStatus.BodyNoAuthorisation'
  }
  return 'Dashboard.Notifications.SwiftaidStatus.BodyNoAccounts'
})

const onReview = () => {
  router.push({ name: 'Account' }).catch(() => {})
}
</script>

<template>
  <section
    v-if="showSwiftaidStatusNotification"
    class="sa-notification-banner sa-notification-banner--warning sa-notification-banner--no-close"
    aria-labelledby="swiftaid-status-notification-title"
  >
    <div class="sa-notification-banner__icon" aria-hidden="true">
      <DashboardNavIcon :name="needsAuthorisation ? 'matching-inactive' : 'matching'" />
    </div>
    <div class="sa-notification-banner__body">
      <h3 id="swiftaid-status-notification-title" class="sa-notification-banner__title">
        {{ t('Dashboard.Notifications.SwiftaidStatus.Title') }}
      </h3>
      <p class="sa-notification-banner__text">
        {{ t(bodyKey) }}
      </p>
      <div class="sa-notification-banner__actions">
        <button
          type="button"
          class="sa-btn-primary sa-btn-primary--compact"
          @click="onReview"
        >
          {{ t('Dashboard.Notifications.SwiftaidStatus.Cta') }}
        </button>
      </div>
    </div>
  </section>
</template>
